
.root [data-slot="field"] {
	margin-bottom: var(--padding-base-y);
}

/*
 * Field.Error's wrapper reserves a message line per field so an appearing error
 * doesn't shift siblings
 */
.root [data-slot="field"] > div:empty {
	min-height: 0;
}
